var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComboboxTestIdFactory } from '../../interactions';
import { ComboboxOption } from '../ComboboxOption';
import styles from './ComboboxGroup.module.css';
export const ComboboxGroup = ({ allOptions, comboboxId, currentOptionIndex, currentRef, currentStyledOptionIndex, 'data-testid': testId, groupIndex, groupOptions, id, innerValue, isMultiselect, keepInputFocus, label, renderOption, select, }) => {
    return (_jsxs("li", { "aria-labelledby": id, role: "group", children: [_jsx("div", { className: styles.OptionGroupLabel, "data-testid": ComboboxTestIdFactory.getComboboxGroupLabelTestId(testId, groupIndex), id: id, onMouseDown: keepInputFocus, children: label }), _jsx("ol", { role: "presentation", children: groupOptions
                    .filter((o) => allOptions.find((filteredOption) => filteredOption.id === o.id))
                    .map((option) => {
                    const isSelected = isMultiselect
                        ? innerValue?.includes(option.id)
                        : innerValue === option.id;
                    const optionIndex = allOptions
                        .map((o) => o.id)
                        .indexOf(option.id);
                    const isCurrent = optionIndex === currentOptionIndex;
                    const isStyledCurrent = isMultiselect
                        ? optionIndex === currentStyledOptionIndex
                        : optionIndex === currentOptionIndex;
                    return (_jsx(ComboboxOption, { comboboxId: comboboxId, "data-testid": testId, isCurrent: isCurrent, isMultiselect: isMultiselect, isSelected: isSelected, isStyledCurrent: isStyledCurrent, keepInputFocus: keepInputFocus, option: option, optionIndex: optionIndex, ref: currentRef, renderOption: renderOption, select: select }, option.id));
                }) })] }));
};
_react_refresh_temp_1 = ComboboxGroup;
$RefreshReg$(_react_refresh_temp_1, "ComboboxGroup");
